import { Component, OnInit, group } from '@angular/core';
import { userService } from '../../service/user.service';
import { HttpErrorResponse } from '@angular/common/http'
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import * as XLSX from 'xlsx';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
//import { forEach } from '@angular/router/src/utils/collection';
import { Http, ResponseContentType } from '@angular/http';
import {commonService} from "../../service/common.service";

import {Globals} from '../.././globals';
import { GroupService } from '../../service/group.service';
@Component({
  selector: 'app-vguser',
  templateUrl: './vguser.component.html',
  styleUrls: ['./vguser.component.css'],
  providers:[GroupService]
})
export class VguserComponent  implements OnInit {
  Stypebox=['Name','Email','Mobile'];
  closeResult: string;
  msg:any;
  studentlist:any;
  student:any;
  isError=false;
  isSuccess=false;
  isErrorExcel=false;
  isSuccessExcel=false;
  iserrorlog=false;
  totalrow:number;
  searchtxt:string;
  typetxt:string;
  notfound=false;
  pageSize = 10;
  currentPage = 0;
  start=0;
  end=10; 
  pageEvent: any;
  studentfiledata:any;
  isclickbutton=false;
  user:any;
  verifyOtpId:any;
  verifyStatus=false;
  isclickbuttonRegisterStudent=false;
  isclickbuttonRegisterVerify=false;

  submitButtun=false;

  msgclass="success";
  exelstdent:any;
  groupId:any;


  constructor(private _group:GroupService,private modalService: NgbModal,private commonService:commonService,private http: Http,private router:Router,private route: ActivatedRoute,private global:Globals) {
    this.route.queryParams.subscribe(params => {
        this.searchtxt=params['search'];
        this.typetxt=params['Stype'];
    });

    this.route.params.subscribe(paramsData => {
       this.groupId = paramsData.id;
  });
   
    this.user=this.commonService.user;
    
   }
pathurl=this.global.siteUrl+'guststudentnotimported.xlsx';
  ngOnInit() {
    this.getstudentlist();
    // set message
    if(localStorage.getItem('isSuccess')=="Yes"){
      this.isSuccess=true;
      this.msg =    localStorage.getItem('msg');
      localStorage.removeItem('isSuccess');
      localStorage.removeItem('msg');
    }
  }

 

// paging handle
  handlePage(e: any){
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    //this.end = (this.currentPage + 1) * this.pageSize;
    this.end = this.pageSize;
    this.start = this.currentPage * this.pageSize;
    this.getstudentlist();    
  }
  
// get course list
  getstudentlist(){
    this._group.groupUser({start:this.start,end:this.end,search:this.searchtxt,groupId:this.groupId}).subscribe((data : any)=>{
            if(data.error==0){
              this.studentlist = data.results.rows;   
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
}





filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  this.searchtxt=txt;
  this.getstudentlist();  
}

delstudent(groupUserId,obj){ 

  if(window.confirm('Do you want to delete this user?')){
    this._group.delUserGroup({groupUserId:groupUserId}).subscribe((data : any)=>{
      if(data.error==0){
        this.studentlist.splice(this.studentlist.indexOf(obj),1)
        this.isSuccess=true;
        this.msg="User has been deleted successfully!";
        //this.getstudentlist()
      }else{
        this.isError = true;
        this.msg=data.error;
      }
  },
  (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
  });
   
  
  } 

} 
 











}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/vguser/vguser.component.ts